import React from "react";
import SendContrcat from "./SendContract";

const ProjectnameContrcat=({handleStep})=>{
return(
<>
{/* <span>Project Name contrcat</span> */}
<SendContrcat handleStep={handleStep} />
</>
)
}
export default ProjectnameContrcat;